import React from "react";
import { useTranslation } from "react-i18next";
import appConfig from "../../../../../config";

function ECAD({ result }) {
  const { t } = useTranslation();
  const text = appConfig.isLoggedIn ? t("ECAD") : t(appConfig.loginText);
  const link = appConfig.isLoggedIn
    ? result["ecad_link"].raw
    : result["ecad_link"].raw
    ? appConfig.loginLink
    : "";
  return (
    <td>
      {link && (
        <a href={link} target="_blank">
          {text}
        </a>
      )}
    </td>
  );
}
export default ECAD;
